import PropTypes from 'prop-types';
import { ReturnStatus } from '../enums/return-status';

export const ReturnStatusPropType = PropTypes.oneOf(Object.values(ReturnStatus).map((value) => value.toString()));

/**
 * @typedef {('Outstanding'|'Received'|'Voided')} ReturnStatusPropType
 */
